/* Quick look. The dialog comes from the quick-look-dialog snippet; each card's
   trigger is followed by its own inert <template>, so nothing is fetched here. */
(function () {
  if (window.dalstrongQuickLookInitialized) return;
  window.dalstrongQuickLookInitialized = true;
  var dialog;
  var lastTrigger;

  function setup() {
    // isConnected: a section re-render in the theme editor replaces the node
    if (dialog && dialog.isConnected) return dialog;

    dialog = document.querySelector('dialog.quick-look');
    if (!dialog) return null;

    // Out of the section wrapper, so section styles cannot reach the panel
    if (dialog.parentElement !== document.body) document.body.appendChild(dialog);

    document.querySelectorAll('dialog.quick-look').forEach(function (other) {
      if (other !== dialog) other.remove();
    });

    dialog.querySelector('.quick-look__close').addEventListener('click', function () {
      dialog.close();
    });

    // Clicking the backdrop lands on the dialog itself
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      var thumb = event.target.closest('.quick-look__thumb');
      if (thumb) {
        switchMedia(thumb);
        return;
      }

      var arrow = event.target.closest('[data-ql-step]');
      if (arrow) {
        step(Number(arrow.dataset.qlStep));
        return;
      }

      var add = event.target.closest('[data-quick-look-add]');
      if (add) addToCart(add);

      // The redirect popup can't open above this dialog, so close it and use the card's own
      var external = event.target.closest('[data-quick-look-external]');
      var card = external && lastTrigger && lastTrigger.closest('[data-card-product-id], .img-container');
      var source = card && card.querySelector('[data-external-checkout-trigger]');
      if (source) {
        event.preventDefault();
        lastTrigger = null;
        dialog.close();
        source.click();
      }
    });

    // Swipe the photo to move through the gallery; the video keeps the gesture for
    // its own seek bar, so visitors leave it with the arrows
    var swipeStart = null;

    dialog.addEventListener(
      'touchstart',
      function (event) {
        var stage = event.target.closest('.quick-look__stage');
        var video = event.target.closest('video');
        swipeStart = null;
        if (!stage || video || event.touches.length !== 1) return;
        swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      },
      { passive: true }
    );

    dialog.addEventListener(
      'touchend',
      function (event) {
        if (!swipeStart) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - swipeStart.x;
        var dy = touch.clientY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        step(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    dialog.addEventListener('close', function () {
      document.body.classList.remove('quick-look-open');
      dialog.querySelectorAll('video').forEach(function (video) { video.pause(); });

      // Give the trigger its focus back; the slider still tries to jump to it,
      // so put it back on the slide the visitor was looking at
      if (lastTrigger) {
        var slider = lastTrigger.closest('.swiper');
        var swiper = slider && slider.swiper;
        var index = swiper ? swiper.activeIndex : null;

        if (lastTrigger.isConnected) lastTrigger.focus({ preventScroll: true });
        lastTrigger = null;

        if (swiper) {
          var restore = function () {
            if (slider.scrollLeft) slider.scrollLeft = 0;
            if (swiper.activeIndex !== index) swiper.slideTo(index, 0);
          };
          restore();
          requestAnimationFrame(restore);
        }
      }
    });

    return dialog;
  }


  // The panel is open, so pull the large renditions in now; switching a
  // thumbnail then paints straight away instead of waiting for the network
  function prefetchMedia() {
    dialog.querySelectorAll('.quick-look__thumb img').forEach(function (small) {
      var large = new Image();
      large.src = largeSrc(small);
    });

    var video = dialog.querySelector('.quick-look__stage-video');
    if (video && video.poster) {
      var poster = new Image();
      poster.src = video.poster;
    }
  }

  function largeSrc(small) {
    return small.src.replace(/([?&]width=)\d+/, '$1800');
  }

  // Arrows walk the same list the thumbnails show
  function step(offset) {
    var thumbs = [].slice.call(dialog.querySelectorAll('.quick-look__thumb'));
    if (!thumbs.length) return;

    var current = thumbs.findIndex(function (item) {
      return item.classList.contains('is-active');
    });
    var next = (current + offset + thumbs.length) % thumbs.length;
    switchMedia(thumbs[next]);
  }

  function switchMedia(thumb) {
    var stage = dialog.querySelector('.quick-look__stage');
    var image = stage.querySelector('.quick-look__stage-image');
    var video = stage.querySelector('.quick-look__stage-video');

    dialog.querySelectorAll('.quick-look__thumb').forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
      item.setAttribute('aria-pressed', String(item === thumb));
    });

    if (thumb.hasAttribute('data-ql-video')) {
      stage.classList.add('is-video');
      return;
    }

    stage.classList.remove('is-video');
    if (video) video.pause();

    // The stage shows the same photo, just a larger rendition of it
    var small = thumb.querySelector('img');
    if (image && small) {
      image.src = largeSrc(small);
      image.alt = small.alt;
    }
  }

  function addToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    // Collection forms already own cart requests, promotion handling and drawer updates.
    if (lastTrigger && lastTrigger.hasAttribute('data-quick-look-native-card')) {
      var card = lastTrigger.closest('[data-card-product-id]');
      var nativeButton = card && card.querySelector('[data-cc-product-form] button[type="submit"]');
      if (!nativeButton || nativeButton.disabled) return;
      button.disabled = true;
      dialog.close();
      nativeButton.click();
      return;
    }

    button.disabled = true;
    // Theme-wide loading state: the label goes transparent and a ring spins
    button.classList.add('btn--loading');

    (window.theme?.cartReads?.request || fetch)((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function () {
        dialog.close();
        var drawer = document.querySelector('.js-drawer-open-cart');
        if (drawer) {
          drawer.click();
        } else {
          window.location.assign(window.location.origin + '/cart');
        }
      })
      .catch(function () {
        var label = button.textContent;
        button.textContent = 'Try again';
        setTimeout(function () {
          button.textContent = label;
        }, 2000);
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('btn--loading');
      });
  }

  function syncNativePrice(trigger, node) {
    if (!trigger.hasAttribute('data-quick-look-native-card')) return;
    var card = trigger.closest('[data-card-product-id]');
    var current = card && card.querySelector('.igPrice');
    var compare = card && card.querySelector('.home-card-discount');
    var panel = node.querySelector('.quick-look__price');
    if (!current || !panel) return;

    // Promotion scripts can update the visible card after Liquid renders its template.
    var currentText = current.textContent.trim();
    var compareText = compare && getComputedStyle(compare).display !== 'none' ? compare.textContent.trim() : '';
    var was = panel.querySelector('.quick-look__price-was');
    var changed = panel.firstElementChild.textContent.trim() !== currentText || (was ? was.textContent.trim() : '') !== compareText;
    panel.firstElementChild.textContent = currentText;
    if (compareText) {
      if (!was) {
        was = document.createElement('span');
        was.className = 'quick-look__price-was';
        panel.firstElementChild.after(was);
      }
      was.textContent = compareText;
    } else if (was) {
      was.remove();
    }
    if (changed) panel.querySelector('.quick-look__badge')?.remove();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-look]');
    if (!trigger) return;

    var template = trigger.nextElementSibling;
    if (!template || template.tagName !== 'TEMPLATE') return;

    var node = setup();
    if (!node) return;

    // The card is covered by a link overlay, so keep the click here
    event.preventDefault();
    event.stopPropagation();

    node.querySelector('.quick-look__body').replaceChildren(template.content.cloneNode(true));
    syncNativePrice(trigger, node);
    node.querySelectorAll('.quick-look__thumb').forEach(function (thumb) {
      thumb.setAttribute('aria-pressed', String(thumb.classList.contains('is-active')));
    });

    // Closing restores focus to whatever was focused here, so hand it over
    // ourselves: the card trigger would otherwise be scrolled back into view
    lastTrigger = trigger;
    trigger.blur();

    node.showModal();
    document.body.classList.add('quick-look-open');
    setTimeout(prefetchMedia, 250);
  });
})();
